import Link from '@/update-monitor/Link'

import IconNewTabLink from '@/assets/icons/ic_external-link.svg'
import Image from 'next/image'
import { Button } from '../ui/button'
import { WebPanel, WebPanelItem } from '../web-panel'

export const HelpCenter = (): JSX.Element => {
  return (
    <div className="mx-auto max-w-[940px]">
      <section>
        <h3 className="mb-2.5 text-base font-bold md:mb-3.5 md:text-[17px] lg:mb-5 lg:text-xl">
          お問い合わせ
        </h3>

        <WebPanel className="px-[21px] lg:px-[37px]">
          <WebPanelItem className="flex items-start justify-between border-b border-b-outline px-0 py-[24px]">
            <p className="pr-[24px] text-xs font-medium leading-[1.5] tracking-widest text-secondary-text md:max-w-[556px] md:text-[13px]">
              <strong className="mb-1 inline-block text-[15px] text-primary-text md:mb-2.5 md:text-lg lg:text-xl">
                LINEでのお問い合わせ
              </strong>
              <br />
              <span className="text-xs md:text-[13px] lg:text-[15px]">
                ラインでお友達登録されている方は、LINEにてお問い合わせください。
                右のQRコードからお友達登録ができます。
              </span>
            </p>
            <div className="flex h-[100px] w-[100px] flex-shrink-0 items-center justify-center rounded-[8px] bg-gray-bg md:w-[200px] lg:h-[130px] lg:w-[284px] lg:rounded-[10px]">
              <Image
                src="/images/QRCode/LINE.png"
                width={110}
                height={110}
                alt="LINE QR Code"
                className="h-[86px] w-[86px] lg:h-[110px] lg:w-[110px]"
              />
            </div>
          </WebPanelItem>

          <WebPanelItem className="flex-col items-start border-none px-0 py-[24px]">
            <p className="text-xs font-medium tracking-widest text-secondary-text md:max-w-[348px] md:text-[13px]">
              <strong className="mb-1 inline-block text-[15px] text-primary-text md:mb-2.5 md:text-lg lg:text-xl">
                フォームでのお問い合わせ
              </strong>
              <br />
              <span className="text-xs md:text-[13px] lg:text-[15px]">
                下記よりお問い合わせください。
              </span>
            </p>
            <Button
              variant="light"
              size="sm"
              className="mt-1 h-[38px] w-[170px] border border-[#5166C7] bg-white px-1 md:mt-3 md:h-[40px] md:w-[220px] lg:mb-[16px]"
              asChild={true}
            >
              <Link
                href="https://support.sonyged.com/hc/ja/requests/new"
                className="inline-flex items-center text-xs font-bold leading-[150%] tracking-wider text-[#5166C7] md:text-[15px]"
                target="_blank"
              >
                お問い合わせフォーム
                <IconNewTabLink width={20} />
              </Link>
            </Button>
          </WebPanelItem>
        </WebPanel>

        <div className="text-center">
          <p className="font-large mt-10 text-center text-xs tracking-widest text-secondary-text md:text-[15px]">
            よくある質問や、アプリの使い方についてはヘルプセンターを参照ください。
          </p>
          <Button
            variant="light"
            size="lg"
            className="mt-6 h-[50px] w-[250px] bg-white md:mt-10 md:h-[60px] md:w-[338px]"
            asChild={true}
          >
            <Link
              href="https://www.sonyged.com/logiq/helpcenter"
              className="inline-flex items-center text-base font-bold leading-[150%] tracking-wider text-[#5166C7] md:text-xl"
              target="_blank"
            >
              ヘルプセンター
              <IconNewTabLink width={28} />
            </Link>
          </Button>
        </div>
      </section>
    </div>
  )
}
